import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProdutividadeIndiceService } from '../produtividade-indice-service/produtividade-indice.service';
import { CrudBase } from './../../../../shared/crud/CrudBase';

@Component({
    selector: 'app-produtividade-indice-cadastro',
    templateUrl: './produtividade-indice-cadastro.component.html',
    styleUrls: ['./produtividade-indice-cadastro.component.css']
})
export class ProdutividadeIndiceCadastroComponent extends CrudBase implements OnInit {

    constructor(service: ProdutividadeIndiceService, toastr: ToastrService) {
        super(service, toastr);

        this.exibirExcluir = false;
        this.exibirNovo = false;
    }

    ngOnInit() {    
    }

}